import React from "react"
import { Link, graphql } from "gatsby"
import { IconContext } from "react-icons";

export default function SpecialItem( data ) {
  return (
    <Link to={ data.to } className="special-item">
      <div className="special-item-icon">
        <IconContext.Provider value={{ color:"white", size:"40" }}>
          <data.icon />
        </IconContext.Provider>
      </div>
      <div className="special-item-content">
        <div className="title">{ data.title }</div>
        <div className="subtitle">{ data.subtitle }</div>
      </div>
    </Link>
  )
}
